import { render, staticRenderFns } from "./ReminderEmailTemplateEdit.vue?vue&type=template&id=6430daf4"
import script from "./ReminderEmailTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./ReminderEmailTemplateEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6430daf4')) {
      api.createRecord('6430daf4', component.options)
    } else {
      api.reload('6430daf4', component.options)
    }
    module.hot.accept("./ReminderEmailTemplateEdit.vue?vue&type=template&id=6430daf4", function () {
      api.rerender('6430daf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderEmailTemplateEdit.vue"
export default component.exports